import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看明细")
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle fs-7" }, null, -1)
const _hoisted_11 = { key: 1 }

import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import ApiService from "@/core/services/ApiService";
import {ElMessage} from 'element-plus';
import {renderThousands} from "@/utils";


export default /*#__PURE__*/_defineComponent({
  props: {
  filters: { type: Object, required: true },
  apiUrl: { type: String, required: true },
  title: { type: String, required: true },
  report_id: { type: Number, default: 1 },
  loading: {type: Boolean, default: false},  // 父组件控制子组件的载入
},
  emits: ['tableData', 'tableField'],
  setup(__props, { emit }) {

const props = __props




const store = useStore();
const dataT = ref<HTMLElement | null>(null);
const tableHeader = ref<Array<any>>([]);
const filters = reactive(props.filters as Object);
// 表格数据
const tableData = ref<any>([]);
// 表格载入延迟
const loading = ref<boolean>(false);

onMounted(() => {
  loadHeader();
});

watch(props, (val) => {
  if (props.loading) loadData();
});

const loadHeader = () => {
  ApiService.get('report/category/indicator', {report_id: props.report_id}).then(({data}) => {
    if (data.length < 1) {
      ElMessage.error('基础数据不足，请与管理员联系！');
    } else {
      let th: Array<any> = [];
      let fields: Array<any> = [];
      for (let d of data) {
        let t = {
          name: d.name,
          key: d.field,
          desc: d.description,
        }
        if (d.field === 'weekly') {
          t['width'] = 165;
          t['fixed'] = true;
        }
        if (d.field === 'gmv') t['width'] = 95;
        if (d.field === 'sale_num') t['width'] = 70;
        if (d.field === 'c_gross_margin') t['width'] = 70;
        if (d.field === 'c_gmv_percent') t['width'] = 70;
        if (d.field === 'c_sale_num_percent') t['width'] = 70;
        if (d.field === 'c_imp_percent') t['width'] = 70;
        if (d.field === 'c_click_percent') t['width'] = 70;
        if (d.field === 'c_add_percent') t['width'] = 70;
        th.push(t);
        if (d.is_display) fields.push(d);
      }
      tableHeader.value = [...th];
      emit('tableField', fields);
    }
  });
}

const loadData = () => {
  loading.value = true;
  ApiService.get(props.apiUrl, filters).then(({data}) => {
    tableData.value = [...data];
    emit('tableData', data);
    loading.value = false;
  });
}

const filtersToString = () => {
  let params = JSON.parse(JSON.stringify(filters));
  if (params['overview_loading'] != undefined) delete params['overview_loading']
  if (params['price_loading'] != undefined) delete params['price_loading']
  params['params'] = JSON.stringify(params['params']);
  return params;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "search", {}, () => [
            _createTextVNode(_toDisplayString(props.title), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: {name: 'report.product.categoryChange', query: filtersToString()},
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "mini"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            align: "center",
            "table-layout": "auto",
            "element-loading-text": "Loading...",
            "empty-text": "没有数据！"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeader.value, (cell, i) => {
                return (_openBlock(), _createBlock(_component_el_table_column, {
                  key: i,
                  prop: cell.key,
                  label: cell.name,
                  sortable: cell.sortable ? 'custom': false,
                  "sort-orders": ['ascending', 'descending'],
                  fixed: cell.fixed,
                  align: "center",
                  "min-width": cell.width ? cell.width : (
                cell.name.length > 3 && cell.name.length < 10 ? (20 + cell.name.length * 15) : 60
              ) + (cell.sortable ? 15 : 0) + (cell.desc ? 13 : 0)
                }, {
                  header: _withCtx((header) => [
                    _createTextVNode(_toDisplayString(header.column.label) + " ", 1),
                    _createVNode(_component_el_tooltip, {
                      effect: "light",
                      placement: "bottom"
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cell.desc), 1)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx((scope) => [
                    (scope.row.weekly==='提升幅度')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          style: _normalizeStyle('background-image: linear-gradient(90deg, '+(scope.row[cell.key][0] === '-' ? '#f10' : '#4dafe2')+' 0, #fff '+scope.row[cell.key].replace('-', '')+')')
                        }, _toDisplayString(scope.row[cell.key]), 5))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(renderThousands)(scope.row[cell.key])), 1))
                  ]),
                  _: 2
                }, 1032, ["prop", "label", "sortable", "fixed", "min-width"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ])
      ])
    ])
  ]))
}
}

})